import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "../lib/i18n";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#0A192F] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="noise-overlay" />
      <div className="relative max-w-lg w-full bg-white p-10 md:p-14 text-center">
        <img src="/logo-shamar.png" alt="Shamar" className="h-16 w-auto mx-auto mb-8" />
        <XCircle className="w-10 h-10 text-[#0A192F]/40 mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-serif-lux text-2xl text-[#0A192F] mb-3">{t.payment.cancelTitle}</h1>
        <p className="text-sm text-[#0A192F]/60 font-light mb-8">{t.payment.cancelText}</p>
        <Link
          to="/#reserver"
          data-testid="cancel-back-booking"
          className="inline-block px-8 py-3.5 bg-[#0A192F] text-[#F0F0F0] text-[13px] tracking-[0.16em] uppercase hover:bg-[#C9A03C] hover:text-[#050B14] transition-colors duration-400"
        >
          {t.payment.backBooking}
        </Link>
      </div>
    </div>
  );
}
